export { Map as default } from './Map';
